import { LucideArrowUp } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';
import { cn } from '~/common/utils/styleUtil';

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  const toggleVisible = useCallback(() => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  useEffect(() => {
    window.addEventListener("scrollend", toggleVisible);
    return () => {
      window.removeEventListener("scrollend", toggleVisible);
    };
  })

  return <button type="button"
    className={cn("duration-500 fixed bottom-2 desktop:bottom-24 rounded bg-secondary text-white p-1 mr-2 desktop:mr-0 desktop:p-1 desktop:hover:py-2",
    visible  ? 'animate-in fade-in' : 'animate-out fade-out invisible')}
    onClick={scrollToTop}
    style={{
      right: 'calc((100vw - var(--container-width)) / 2)'
  }}
    data-testid={'scroll-to-top-button'}
  >
    <LucideArrowUp size={24} />
  </button>
}